import { ContentfulImage } from './interfaces'

export const getImageAspectRatio = (image: ContentfulImage): number | null => {
  const imageWidth = image?.file?.details?.image?.width
  const imageHeight = image?.file?.details?.image?.height
  return imageWidth / imageHeight || null
}
